import type { Basket } from "~/interfaces/basket";
import type { Place, PlacePrice } from "~/interfaces/publisher";

class BasketService {
  setBasket(basket: Basket) {
    if (!import.meta.client) return;
    localStorage.setItem('basket', JSON.stringify(basket));
  }

  getBasket() {
    if (!import.meta.client) return {};
    return JSON.parse(localStorage.getItem('basket') || '{}');
  }

  clearBasket() {
    if (!import.meta.client) return;
    localStorage.removeItem('basket');
  }

  addPlace(place: Place & { format: PlacePrice | null }) {
    if (!import.meta.client) return false;
    let basket = this.getBasket();

    if (Array.isArray(basket)) {
      basket = {
        places: [],
      };
      basket.places.push({
        ...place,
        quantity: 1,
      });
      this.setBasket(basket);
      return true;
    } else {
      basket.places = basket.places || [];
      const existingPlaceIndex = basket.places?.findIndex(
        (p: any) => p.id === place.id && this.formatEquals(p.format, place.format)
      );

      if (existingPlaceIndex !== -1 && existingPlaceIndex !== undefined) {
        // Если такой же формат уже существует, увеличиваем счетчик
        basket.places[existingPlaceIndex].quantity = (basket.places[existingPlaceIndex].quantity || 1) + 1;
      } else {
        // Если формат новый, добавляем его как отдельный item
        basket.places.push({
          ...place,
          quantity: 1,
        });
      }
      this.setBasket(basket);
      return true;
    }
  }

  private formatEquals(format1: PlacePrice | null, format2: PlacePrice | null): boolean {
    if (!format1 && !format2) return true;
    if (!format1 || !format2) return false;
    return format1.priceType === format2.priceType;
  }

  removePlace(placeId: number, format: PlacePrice | null) {
    if (!import.meta.client) return false;
    let basket = this.getBasket();
    
    if (!basket.places) return;

    const index = basket.places.findIndex(
      (p: any) => p.id === placeId && this.formatEquals(p.format, format)
    );

    if (index !== -1) {
      basket.places.splice(index, 1);
      this.setBasket(basket);
      return true;
    }

    return false;
  }

  updateQuantity(placeId: number, format: PlacePrice | null, quantity: number) {
    if (!import.meta.client) return false;
    let basket = this.getBasket();
    
    if (!basket.places) return;

    const item = basket.places.find(
      (p: any) => p.id === placeId && this.formatEquals(p.format, format)
    );

    if (item) {
      item.quantity = Math.max(1, quantity);
      this.setBasket(basket);
      return true;
    }

    return false;
  }
}

export default new BasketService()
